import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import { columns } from './table-column';

export default function ActivitySaleGuestDetailTable(props: {
  guestIndex: number;
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const name = `approvalable.activitySales.${props.parentIndex}.activitySaleGuests.${props.guestIndex}.activitySaleGuestDetails`;
  const _value = HOCWatchValue({ keys: [name] });
  const value = _value[name];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns(t)}
        data={value}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
